import { ObjectId } from "./common";

export interface IdResponse {
  id: string;
}

export interface Bot {
  id: ObjectId;
  name: string;
  description: string;
  chats: Chat[];
}

export interface Message {
  id: ObjectId;
  content: string;
  type: "human" | "ai";
  insertion_date: Date;
  feedback?: FeedbackThumbs;
}

export interface Chat {
  id: ObjectId;
  title: string;
  favourite: boolean;
  updated_at: Date;
  original_chat_id?: ObjectId;
}

export interface BotChat extends Chat {
  messages: Message[];
  bot: {
    id: ObjectId;
    name?: string;
  };
}

export interface PDFChat extends Chat {
  messages: Message[];
  bot: {
    asset_id: ObjectId;
  };
}

export enum FeedbackThumbs {
  "THUMBS_UP" = "THUMBS_UP",
  "THUMBS_DOWN" = "THUMBS_DOWN",
}
